//Generated File 
export const APP_URL = ``;
export const GUI_BASE_PATH = ``;
